module.exports = __webpack_public_path__ + "static/img/coupon2.a99eb418.png";